/*
 * product-custom-purchase-final.js
 * ----------------------------------------------------------------------
 * VERSIÓN DEFINITIVA (LISTA PARA COPIAR Y PEGAR):
 * 1. Título visual con "/" (ej: Rose Nectar / 32 servings).
 * 2. Lee opción interna con "|" (ej: 32 servings | 8oz).
 * 3. IDs de 32 Servings corregidos para que funcione el carrito.
 * 4. Botón Add to Cart dinámico con precios.
 */

console.log("🐛 [INIT] Ejecutando script product-custom-purchase.js");

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = window.Shopify.formatMoney || function(cents, format = "{{ amount }}") {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const amount = cents / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD', 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0
    }).format(amount);
};

document.addEventListener('DOMContentLoaded', () => {
    
    // **CONSTANTES**
    const FREE_SHIPPING_THRESHOLD_CENTS = 10000; // $100.00 USD
    const DEFAULT_SHIPPING_TEXT = "+ $6.95 shipping"; 

    // **MAPEO DE PLANES**
    const SELLING_PLAN_MAP = {
        // --- 32 SERVINGS (IDs CONFIRMADOS) ---
        "32 servings | 8oz": {
            "1-Pack": 5758386395, // Mensual
            "3-Pack": 6452904155,
            "6-Pack": 6451888347 
        },
        // --- 64 SERVINGS (Fallback) ---
        "64 servings | 16oz": {
            "1-Pack": 5758517467,
            "3-Pack": 6615892187,
            "6-Pack": 6615859419
        }
    };
    
    // Referencias DOM
    const productForm = document.querySelector('.product-single__form'); 
    if (!productForm) return;

    const formContainer = productForm.closest('[data-section-type="product-template"]') || productForm.closest('[data-product-container]');
    const sectionId = formContainer ? formContainer.dataset.sectionId : null; 
    const productJSONScript = formContainer 
        ? formContainer.querySelector(`#ProductJson-${sectionId}`) 
        : document.querySelector('script[type="application/json"][data-product-json]');

    const productData = productJSONScript ? JSON.parse(productJSONScript.textContent) : window.customProductData; 
    
    // --- REFERENCIAS AL TÍTULO ---
    const productTitleElement = document.querySelector('.product-single__title');
    
    // Limpiamos el título base. Usamos split para obtener solo el nombre del producto
    let baseTitle = '';
    if (productTitleElement) {
        // Separa por | o por / y se queda con la primera parte (El nombre)
        baseTitle = productTitleElement.textContent.split('|')[0].split('/')[0].trim();
    }

    const productContainer = document.querySelector('.custom-subscription-widget-container');
    const subscriptionIdInput = productForm.querySelector('input[name="selling_plan"]');
    const variantIdInput = productForm.querySelector('[name="id"]');
    
    const totalCurrentPrice = document.querySelector('.total-current-price');
    const totalComparePrice = document.querySelector('.total-compare-price');
    const totalSaveAmount = document.querySelector('.total-save-amount'); 
    const btnTextElement = document.querySelector('.btn--add-to-cart .btn__text');
    const shippingPriceElement = document.querySelector('#buy-once-option .shipping-price');

    const packButtons = productContainer ? productContainer.querySelectorAll('.pack-button') : [];
    const servingsRadios = productForm.querySelectorAll('input[name="option1"]'); 
    const purchaseRadios = productContainer ? productContainer.querySelectorAll('input[name="purchase_option"]') : []; 

    let selectedServings = '';
    
    // --- FUNCIONES CORE ---
    
    const getPackMultiplier = (packValue) => {
        const match = packValue.match(/^(\d+)/);
        return match ? parseInt(match[1], 10) : 1;
    }

    const getTargetVariantByOptions = (servings, pack) => {
        if (!productData || !servings || !pack) return null;
        return productData.variants.find(v => v.option1 === servings && v.option2 === pack);
    };
    
    const getBuyOnceBasePrice = (servings) => {
        const buyOnceVariant = getTargetVariantByOptions(servings, "1-Pack");
        return buyOnceVariant ? buyOnceVariant.price : 0;
    };

    const getTargetVariantById = (id) => {
        if (!productData || !id) return null;
        return productData.variants.find(v => v.id.toString() === id.toString());
    };

const getTargetData = (isSubscription, servings, pack, currentVariantId) => {
    let price = 0;
    let compareAt = 0;
    let sellingPlan = '';
    
    let targetVariant = getTargetVariantByOptions(servings, pack);
    if (!targetVariant && currentVariantId) {
        targetVariant = getTargetVariantById(currentVariantId);
    }

    if (!targetVariant) return { variant: null, price: 0, compareAt: 0, sellingPlan: '' };

    // 1. Obtener la variante base (1-Pack) para las comparaciones
    const variantBase1Pack = getTargetVariantByOptions(servings, "1-Pack");
    
    // 2. Determinar el precio de referencia unitario (Prioridad: Compare At > Price)
    let unitReferencePrice = 0;
    if (variantBase1Pack) {
        unitReferencePrice = variantBase1Pack.compare_at_price || variantBase1Pack.price;
    } else {
        // Fallback por si no encuentra el 1-Pack
        unitReferencePrice = targetVariant.compare_at_price || targetVariant.price;
    }

    const multiplier = getPackMultiplier(pack);
    const totalReferencePrice = unitReferencePrice * multiplier;

    if (isSubscription) {
        sellingPlan = SELLING_PLAN_MAP[servings]?.[pack] || '';

        const sellingPlanAllocation = targetVariant.selling_plan_allocations
            ? targetVariant.selling_plan_allocations.find(alloc => alloc.selling_plan_id.toString() === sellingPlan.toString())
            : null;
        
        if (sellingPlanAllocation && sellingPlanAllocation.price_adjustments.length > 0) {
            price = sellingPlanAllocation.price_adjustments[0].price;
            // Usamos la referencia construida (Precio 1-pack * cantidad)
            compareAt = totalReferencePrice; 
        } else {
            price = targetVariant.price;
            compareAt = totalReferencePrice; 
        }
    } else {
        // Buy Once: Usamos el tachado real de la variante o nuestra referencia construida
        price = targetVariant.price;
        compareAt = targetVariant.compare_at_price || totalReferencePrice; 
    }
    
    return { variant: targetVariant, price: price, compareAt: compareAt, sellingPlan: sellingPlan };
};

    // --- FUNCIÓN TÍTULO (LÓGICA CORREGIDA) ---
    const updateProductTitle = (servingsOption) => {
        if (!productTitleElement || !baseTitle || !servingsOption) return;

        // 1. Extraemos el texto limpio del input.
        // El input tiene: "32 servings | 8oz"
        // Hacemos split('|') para quedarnos solo con "32 servings"
        const servingsSegment = servingsOption.split('|')[0].trim();

        if (servingsSegment) {
            // 2. Lo mostramos con "/" como pediste
            productTitleElement.textContent = `${baseTitle}`;
        } else {
            productTitleElement.textContent = baseTitle;
        }
    };

    // --- FUNCIÓN ACTUALIZACIÓN PRINCIPAL ---
    const updateFormAndPrices = () => {
        const selectedRadio = productContainer.querySelector('input[name="purchase_option"]:checked');
        if (!selectedRadio || !selectedServings) return;

        const purchaseOptionValue = selectedRadio.value; 
        const isSubscription = purchaseOptionValue !== 'onetime';
        
        let targetPack = '1-Pack';
        if (isSubscription) {
             targetPack = selectedRadio.dataset.packValue; 
        } else {
             const selectedPackBtn = productContainer.querySelector('.purchase-option-onetime .pack-button.is-selected-pack');
             if(selectedPackBtn) targetPack = selectedPackBtn.dataset.packValue;
        }

        const finalData = getTargetData(isSubscription, selectedServings, targetPack, variantIdInput ? variantIdInput.value : null);
        
        if (!finalData.variant) return;

        // 1. ACTUALIZAR TÍTULO
        updateProductTitle(selectedServings);

        // 2. ACTUALIZAR INPUTS OCULTOS
        if (variantIdInput) {
            variantIdInput.value = finalData.variant.id;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (subscriptionIdInput) {
            subscriptionIdInput.value = finalData.sellingPlan; 
        }

        // 3. ACTUALIZAR PRECIOS VISUALES
        updateAllPurchaseOptionPrices(selectedServings, targetPack);
        updateTotalFooterPrices(finalData.price, finalData.compareAt);

        // 4. ACTUALIZAR BOTÓN CON PRECIO Y TACHADO
        if(btnTextElement) {
             if (finalData.variant.available) {
                 let btnHTML = "ADD TO CART";
                 const currentPriceFormatted = Shopify.formatMoney(finalData.price);
                 btnHTML += ` <span style="margin-left: 5px;">${currentPriceFormatted}</span>`;

                 if (finalData.compareAt > finalData.price) {
                     const comparePriceFormatted = Shopify.formatMoney(finalData.compareAt);
                     btnHTML += ` <s style="opacity: 0.7; font-weight: 400; margin-left: 5px;">${comparePriceFormatted}</s>`;
                 }
                 btnTextElement.innerHTML = btnHTML;
             } else {
                 btnTextElement.textContent = "SOLD OUT";
             }
        }
        
        // 5. ENVÍO GRATIS
        if (shippingPriceElement && purchaseOptionValue === 'onetime') {
            if (finalData.price >= FREE_SHIPPING_THRESHOLD_CENTS) {
                shippingPriceElement.textContent = "Free Shipping";
                shippingPriceElement.style.fontWeight = 'bold';
            } else {
                shippingPriceElement.textContent = DEFAULT_SHIPPING_TEXT;
                shippingPriceElement.style.fontWeight = 'normal';
            }
        }
    };

    const updateTotalFooterPrices = (totalPriceCents, totalCompareAtCents) => {
        if (!totalCurrentPrice) return;
        const saveAmountCents = totalCompareAtCents - totalPriceCents;
        totalCurrentPrice.textContent = Shopify.formatMoney(totalPriceCents);
        
        if (saveAmountCents > 0 && totalComparePrice) {
            totalComparePrice.textContent = Shopify.formatMoney(totalCompareAtCents);
            totalComparePrice.style.display = 'inline';
            totalComparePrice.style.visibility = 'visible';
            totalSaveAmount.textContent = `Save ${Shopify.formatMoney(saveAmountCents)}`;
            totalSaveAmount.parentElement.style.visibility = 'visible';
        } else if (totalComparePrice) {
            totalComparePrice.style.display = 'none';
            totalComparePrice.style.visibility = 'hidden';
            totalSaveAmount.parentElement.style.visibility = 'hidden';
        }
    };

    const getNativePackRadio = (packValue) => {
        return productForm.querySelector(`input[name="option2"][value="${packValue}"]`);
    };
    
    const updateAllPurchaseOptionPrices = (currentServings, currentSelectedPack) => {
        const buyOnceLabel = document.querySelector('#buy-once-option');
        if (buyOnceLabel) {
            const variantData = getTargetData(false, currentServings, currentSelectedPack, null);
            if (variantData.variant) {
                fillPriceDetails(buyOnceLabel, variantData.price, variantData.compareAt);
            }
        }
        productContainer.querySelectorAll('.purchase-option-label:not(.purchase-option-onetime)').forEach(label => {
            const radioInput = label.querySelector('input[name="purchase_option"]');
            const packValue = radioInput ? radioInput.dataset.packValue : null;
            if (packValue) {
                const variantData = getTargetData(true, currentServings, packValue, null); 
                if (variantData.variant) {
                    fillPriceDetails(label, variantData.price, variantData.compareAt);
                }
            }
        });
    };

    const fillPriceDetails = (label, price, compare) => {
        const pDisplay = label.querySelector('.current-price-display');
        const cDisplay = label.querySelector('.compare-at-price-display');
        const sLabel = label.querySelector('.savings-label');

        if(pDisplay) pDisplay.textContent = Shopify.formatMoney(price);
        if(cDisplay) {
            if(compare > price) {
                cDisplay.textContent = Shopify.formatMoney(compare);
                cDisplay.style.display = 'inline';
                cDisplay.style.visibility = 'visible';
            } else {
                cDisplay.style.display = 'none';
                cDisplay.style.visibility = 'hidden';
            }
        }
        if(sLabel) {
            if(compare > price) {
                const pct = Math.round(((compare - price) / compare) * 100);
                sLabel.textContent = `Save ${pct}%`;
                sLabel.style.display = 'inline-block';
            } else {
                sLabel.style.display = 'none';
            }
        }
    };

    const handlePurchaseOptionChange = (e) => {
        const target = e.target;
        const selectedRadio = target;

        purchaseRadios.forEach(radio => { radio.closest('label').classList.remove('is-selected'); });
        selectedRadio.closest('label').classList.add('is-selected');

        const targetPackValue = target.value !== 'onetime' 
            ? selectedRadio.dataset.packValue 
            : productContainer.querySelector('.purchase-option-onetime .pack-button.is-selected-pack')?.dataset.packValue || '1-Pack'; 

        syncPackRadio(targetPackValue); 
    };
    
    const syncPackRadio = (targetPackValue) => {
        const nativePackRadio = getNativePackRadio(targetPackValue);
        if (nativePackRadio) {
            setTimeout(() => {
                nativePackRadio.click();
                updateFormAndPrices();
            }, 10);
        } else {
            updateFormAndPrices();
        }
    };
    
    // Listeners
    servingsRadios.forEach(radio => {
        if (radio.checked) { selectedServings = radio.value; }
        radio.addEventListener('change', (e) => {
            selectedServings = e.target.value;
            setTimeout(updateFormAndPrices, 50); 
        });
    });

    purchaseRadios.forEach(radio => {
        radio.addEventListener('change', handlePurchaseOptionChange);
    });
    
    packButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            packButtons.forEach(btn => { btn.classList.remove('is-selected-pack'); });
            e.target.classList.add('is-selected-pack');
            const targetPackValue = e.target.dataset.packValue;
            
            const currentMode = document.querySelector('input[name="purchase_option"]:checked').value;
            if (currentMode === 'onetime') {
                syncPackRadio(targetPackValue);
            }
        });
    });

    // INIT
    const initialServingsRadio = productForm.querySelector('input[name="option1"]:checked');
    if(initialServingsRadio) selectedServings = initialServingsRadio.value;
    
    if (selectedServings) {
        const checkedRadio = document.querySelector('input[name="purchase_option"]:checked');
        if (checkedRadio) {
            setTimeout(() => checkedRadio.dispatchEvent(new Event('change')), 100);
        } else {
            updateFormAndPrices();
        }
    }
});